import { render, staticRenderFns } from "./club.html?vue&type=template&id=65c10a08&"
import script from "./club.js?vue&type=script&lang=js&"
export * from "./club.js?vue&type=script&lang=js&"
import style0 from "./club.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c10a08')) {
      api.createRecord('65c10a08', component.options)
    } else {
      api.reload('65c10a08', component.options)
    }
    module.hot.accept("./club.html?vue&type=template&id=65c10a08&", function () {
      api.rerender('65c10a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/fintopia-club/index/club.vue"
export default component.exports